import { useState } from 'react';
import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import authHeader from '../config/authHeader';

const useDoxExt = () => {
    const { token, logout } = useAuth();

    const [doxExt, setDoxExt] = useState([]);
    const [doxExtByUUID, setDoxExtByUUID] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getHeaders = (json = false) => ({
        Authorization: `Bearer ${token}`,
        ...(json ? { 'Content-Type': 'application/json' } : {})
    });

    const fetchAllDoxExt = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDoxExt`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return;
            }

            if (!response.ok) throw new Error('Erreur réseau lors de la récupération des doxExt');

            const data = await response.json();
            setDoxExt(data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const createDoxExt = async (newEntry) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_createDoxExt`, {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify(newEntry),
            });

            if (response.status === 401) {
                logout();
                return;
            }

            if (!response.ok) throw new Error('Erreur réseau lors de la création d’un doxExt');

            const createdData = await response.json();
            setDoxExt(prev => [...prev, createdData]);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const fetchDoxExtByUUID = async (uuid) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDoxExtByUUID?uuid=${uuid}`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return [];
            }

            if (!response.ok) throw new Error('Erreur réseau lors de la récupération des doxExt par UUIDs');

            const data = await response.json();
            setDoxExtByUUID(data);
            return data;
        } catch (err) {
            setError(err.message);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const fetchBlobBase64ByUUID = async (uuid) => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.apiBaseUrl}/4DACTION/KST_getDoxExtBlobBase64ByUUID?uuid=${uuid}`, {
                method: 'GET',
                headers: authHeader(),
            });

            if (response.status === 401) {
                logout();
                return null;
            }

            if (!response.ok) throw new Error('Erreur réseau lors de la récupération du fichier BLOB en base64');

            const data = await response.json();
            return data.BLOB_B64;
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        doxExt,
        doxExtByUUID,
        fetchAllDoxExt,
        createDoxExt,
        fetchDoxExtByUUID,
        fetchBlobBase64ByUUID,
        loading,
        error
    };
};

export default useDoxExt;
